import { FC } from 'react';
import {
  StoryDetailHeaderAdvertAvatar,
  StoryDetailHeaderCloseButton,
  StoryDetailHeaderDescription,
} from '#advertStory/detail';
import storyDetailHeaderCss from '../../assets/detail/story-detail-header.module.scss';

const StoryDetailHeader: FC = () => (
  <div className={storyDetailHeaderCss.storyDetailHeader}>
    <StoryDetailHeaderAdvertAvatar />
    <StoryDetailHeaderDescription />
    <StoryDetailHeaderCloseButton />
  </div>
);

export { StoryDetailHeader };
